import React from 'react'
import PageLoader from './PageLoader';
import ToastControl from './ToastControl';
import ConfirmBox from './ConfirmBox';

import { BaseViewModel } from '../Core';


export interface MasterControlProps {
    Model: BaseViewModel
}

export default function MasterControl(props: MasterControlProps) {
    const { Model } = props;
    var model = Model;
    return (
        <div>
            <PageLoader IsLoading={model.IsPageLoading}></PageLoader>
            <ToastControl Messages={model.Messages} OnToastEntered={model.OnToastEntered} ></ToastControl>
            <ConfirmBox
                CancelButtonText={model.ConfirmBoxCancelText}
                Message={model.ConfirmBoxMessage}
                OkButtonText={model.ConfirmBoxOkText}
                Open={model.ConfirmBoxIsOpen}
                Title={model.ConfirmBoxTitle}
                OnButtonClick={model.ConfirmBoxOnButtonClick}></ConfirmBox>
        </div>
    );
}